/**
 *
 */
export class WebGlExtensionCheck {
  /**
   * Exact supported extensions list reported by devices which produce a black screen / black flickering
   * in PixiJS WebGL renderer with preserveFrameBuffer enabled.
   */
  private static noFrameBufferSupport: string[] = [
    "EXT_blend_minmax",
    "EXT_shader_texture_lod",
    "OES_standard_derivatives",
    "OES_vertex_array_object",
    "WEBGL_compressed_texture_etc1",
    "WEBGL_debug_renderer_info",
    "WEBGL_debug_shaders",
    "WEBGL_depth_texture",
    "WEBKIT_WEBGL_depth_texture",
    "WEBGL_lose_context",
    "WEBKIT_WEBGL_lose_context"
  ];

  /**
   *
   * @param gl
   */
  public static frameBufferSupport(gl: WebGLRenderingContext): boolean {
    return (
      JSON.stringify(gl.getSupportedExtensions()) === JSON.stringify(this.noFrameBufferSupport)
    );
  }

  /**
   *
   * @param gl
   */
  public static frameBufferSupportCheck(): boolean {
    const contextOptions = { stencil: true, failIfMajorPerformanceCaveat: true };
    try {
      if (!("WebGLRenderingContext" in window)) return false;
      const canvas = document.createElement("canvas");
      let gl: WebGLRenderingContext =
        (canvas.getContext("webgl", contextOptions) as WebGLRenderingContext) ||
        (canvas.getContext("experimental-webgl", contextOptions) as WebGLRenderingContext);
      const p = WebGlExtensionCheck.frameBufferSupport(gl);
      if (gl) {
        const loseContext = gl.getExtension("WEBGL_lose_context");
        if (loseContext) loseContext.loseContext();
      }
      gl = null;
      return p;
    } catch (e) {
      return false;
    }
  }
}
